
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Team',

    metaInfo: { title: 'Team' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'team',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'team',
      },
    },
  }
</script>
